import React, { Component } from 'react';
import { FontIcon } from 'react-md';
 
class Breadcrumb extends Component {
    
    constructor(props) {
        super(props);

        this.state = {
            
        }
    }

    render() {

        // const { title, url } = this.props;

        return (
            <div className="tw-breadcrumb">
                <h3>{this.props.title}</h3>
                <ol className="tw-breadcrumb-list">
                    <li className="tw-breadcrumb-item"><a href="/clientes">Home</a></li>
                    <li className="tw-breadcrumb-item active"><FontIcon>keyboard_arrow_right</FontIcon>{this.props.title}</li>
                </ol>
            </div>
        )
    }
}

export default Breadcrumb;


// WEBPACK FOOTER //
// ./src/components/Breadcrumb.js